<template>
  <div>
    <!-- 返回 开始 -->
    <div class="page_topbox">
      <img class="page_topreturn" src="/static/fanhui.png" @click="pageReturn()" />
      <div class="page_toptext">提现详情</div>
      <img class="page_topreturnindex" src="/static/fanhuishouye.png" @click="pageToIndex()"/>
    </div>
    <!-- 返回 结束 -->
    <div class="page_top list_top">
      <div class="icon">
        <img src="/static/newprojecticon/daishenhe.png" class="iconimg" />
        <span>{{withdrawDetail.status_str}}</span>
      </div>
    </div>

    <div class="withdraw_preview">
      <div class="withdraw_preview_bd">
        <div class="withdraw_preview_item" v-if="withdrawDetail.card_no && withdrawDetail.withdraw_type!=3">
          <div class="withdraw_preview_label">转让账号</div>
          <div class="withdraw_preview_value">{{withdrawDetail.card_no}}</div>
        </div>
        <div class="withdraw_preview_item">
          <div class="withdraw_preview_label">账户类型</div>
          <div class="withdraw_preview_value">{{withdrawDetail.withdraw_type_str}}</div>
        </div>
        <div class="withdraw_preview_item">
          <div class="withdraw_preview_label">转让时间</div>
          <div class="withdraw_preview_value">{{withdrawDetail.created_at_str}}</div>
        </div>
        <div class="withdraw_preview_item">
          <div class="withdraw_preview_label">转让积分</div>
          <div class="withdraw_preview_value">{{withdrawDetail.money}}</div>
        </div>
        <div class="withdraw_preview_item">
          <div class="withdraw_preview_label">到账金额</div>
          <div class="withdraw_preview_value">￥{{withdrawDetail.real_money}}</div>
        </div>
        <div class="withdraw_preview_item">
          <div class="withdraw_preview_label">转让状态</div>
          <div class="withdraw_preview_value">{{withdrawDetail.status_str}}</div>
        </div>
      </div>
      <div class="withdraw_preview_ft">
        <div class="withdraw_preview_btn withdraw_preview_btn_primary" @click="hua">
          <a>返回</a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  // import swal from 'sweetalert'
  import httper from '../../api/http';

  export default {
    data() {
      return {
        id: "",
        withdrawDetail: {}
      }
    },
    created() {
      let that = this
      //上一页面传过来的参数
      if (that.$route.query.id) {
        that.id = that.$route.query.id
      } else {
        if (!that.id) {
          this.$toast({
            message: '参数错误',
          });
          // setTimeout(function () {
          //     history.back()
          // }, 1000)
          return
        }
      }

      this.request('getWithdrawList', {
        order_no: that.id
      })
    },
    mounted() {

    },
    methods: {
      pageReturn(){
        this.$router.go(-1)
      },
      pageToIndex(){
        this.$router.push({
          path:"/"
        })
      },
      hua() {
        this.$router.go(-1)
      },
      //调用接口
      request(type = '', requestData = {}) {
        let that = this
        let data = {}
        switch (type) {
          // 获取订单信息列表
          case 'getWithdrawList':
            httper.post('user/withdraw-list', requestData, res => {
              for (var i = 0; i < res.data.length; i++) {
                if (parseInt(res.data[i].id) === parseInt(that.id)) {
                  that.withdrawDetail = res.data[i]
                  //console.log("withdrawDetail", this.data.withdrawDetail)
                }
              }
            }, true)
            break
        }
      },

    }
  }
</script>
<style scoped>
  .list_top {
    background-image: url(../../../static/newprojecticon/zhifubg.png);
    background-size: contain;
    height: 153px;
  }

  .icon {
    width: 100%;
    height: 35%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }

  .iconimg {
    width: 40px;
    height: 40px;
    margin-bottom: 15px;
  }

  .icon_text {
    font-size: 15px;
    font-weight: 400;
    color: rgba(255, 255, 255, 1);
  }

  .withdraw_preview {
    position: relative;
    background-color: #fff;
    position: absolute;
    /* top: 119px; */
    top: 180px;
    width: 90%;
    margin: 0 20px;
    box-shadow: 0px 4px 5px 2px rgba(187, 187, 187, 0.3);
    border-radius: 0px 0px 8px 8px;
  }

  .withdraw_preview:before {
    content: " ";
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    height: 1px;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
    color: rgba(0, 0, 0, 0.1);
    -webkit-transform-origin: 0 0;
    transform-origin: 0 0;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
  }

  .withdraw_preview_bd {
    padding: 16px;
    font-size: 0.9em;
    text-align: right;
    color: rgba(0, 0, 0, 0.5);
    line-height: 2;
  }

  .withdraw_preview_item {
    overflow: hidden;
  }

  .withdraw_preview_label {
    float: left;
    margin-right: 1em;
    min-width: 4em;
    color: rgba(0, 0, 0, 0.5);
    text-align: justify;
    -moz-text-align-last: justify;
    text-align-last: justify;
  }

  .withdraw_preview_value {
    display: block;
    overflow: hidden;
    word-break: normal;
    word-wrap: break-word;
    color: rgba(0, 0, 0, 0.9);
  }

  .withdraw_preview_ft {
    position: relative;
    line-height: 50px;
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
  }

  .withdraw_preview:after {
    content: " ";
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    height: 1px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.1);
    color: rgba(0, 0, 0, 0.1);
    -webkit-transform-origin: 0 100%;
    transform-origin: 0 100%;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
  }

  .withdraw_preview_btn_primary {

  }

  .withdraw_preview_btn {
    position: relative;
    display: block;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    text-align: center;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
  }
</style>



// WEBPACK FOOTER //
// src/pages/account/withdrawDetail.vue